import getApiInstance from 'data/common/ApiCallGenerique';
import { logInUser } from 'data/user/actions';

const apiCaller = getApiInstance();

function apiAuthProvider(providerAuthCode, providerType, srcType) {
    return dispatch => {
        return apiCaller
            .providerAuthentification(providerAuthCode, providerType, srcType)
            .then(result => {
                dispatch(logInUser(result.data.profile));
                return result.data.profile;
            })
            .catch(e => {
                throw e;
            });
    };
}
export { apiAuthProvider };



// WEBPACK FOOTER //
// ./scenes/Login/actions.js